import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import * as Sentry from "@sentry/browser";

import { makeRequest } from "./util";

export const DestinationOAuth = ({ destinationURL, destinationName }) => {
  const params = new URLSearchParams(useLocation().search);
  const history = useHistory();
  const alert = useAlert();

  const errorURL = `${destinationURL}?error=Failed+to+complete+OAuth`;

  if (!params.get("state")) {
    const err = new Error("Unable to find 'state' parameter for OAuth.");
    console.log(err);
    Sentry.captureException(err);
    alert.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  if (!params.get("code")) {
    const err = new Error("Unable to find 'code' parameter for OAuth.");
    console.log(err);
    Sentry.captureException(err);
    alert.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  const request = {
    integration_name: destinationName,
    state: params.get("state"),
    code: params.get("code"),
  };

  makeRequest("complete_oauth_flow", request)
    .then(() => {
      history.push(destinationURL);
    })
    .catch((err) => {
      console.log(err);
      alert.error("Failed to complete OAuth");
      Sentry.captureException(err);
      history.push(errorURL);
    });

  return null;
};
